import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

import { LedgerPage } from './pages';

export const LedgerRoutes: React.FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route path={match.path} exact component={LedgerPage} />
    <Redirect to={match.path} />
  </Switch>
);
